import { RouteObject, Outlet } from "react-router-dom"
import List from "@contact/pages/List"
import Detail from "@contact/pages/Detail"
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";
import { Protected } from "utils/auth/protect"

const ContactRoutes : RouteObject[] = [
  {
    path: "contact",
    element: (
      <ProvideAuth>
        <AuthedUrqlProvider>
          <Protected>
            <Outlet />
          </Protected>
        </AuthedUrqlProvider>
      </ProvideAuth>
    ),
    children: [
      { index: true, element: <List /> },
      { path: ":id", element: <Detail /> },
    ],
  },
]

export default ContactRoutes
